import React, { cloneElement, isValidElement } from 'react';
import styles from '../styles.module.css';
import { Service, ServiceCategory } from '@/commonTypes';
import MainIcons from '@/icons/main';
import AppLink from '@/components/common/AppLink';
import { blogBg, lightBg, lightBgIcon } from '@/functions/formats';
import ServiceSubCategoryComponent from './ServiceSubCategoryComponent';
import AppImage from '@/components/common/AppImage';

type ServiceGroupProps = {
  g: ServiceCategory;
  i: number;
};
export default function ServiceGroup({ g, i }: ServiceGroupProps) {
  return (
    <div key={g?.title} className={styles.group}>
      <div className={styles.groupHead}>
        <div className={styles.groupIcon} style={{ background: blogBg(i) }}>
          {g?.image?.name ? (
            <AppImage src={g.image.name} width={16} height={16} className={styles.groupIconImage} />
          ) : isValidElement(g?.icon) ? (
            cloneElement(g?.icon, {
              fill: '#fff',
              width: `${'16px'}`,
              height: `${'16px'}`,
            })
          ) : (
            g?.icon
          )}
        </div>
        <h3 className={styles.groupTitle}>{g?.title}</h3>
        <div className={styles.rule} />
      </div>

      <div className={styles.grid}>
        {g?.sub_categories?.map((it, index) => (
          // <AppLink key={it?.title} href={`/service/${it?.slug}`} className={styles.item}>
          //   <div className={styles.itemIcon} style={{ background: lightBg(index) }}>
          //     {/* {isValidElement(it?.icon)
          //       ? cloneElement(it?.icon, {
          //           fill: lightBgIcon(index),
          //           width: `${'16px'}`,
          //           height: `${'16px'}`,
          //         })
          //       : it?.icon} */}
          //     <MainIcons.notifIcon fill={lightBgIcon(index)} width="16px" height="16px" />
          //   </div>
          //   <span className={styles.itemLabel}>{it?.title}</span>
          //   <MainIcons.arrowIcon className="rotate-rtl" width="16px" height="16px" />
          // </AppLink>
          <ServiceSubCategoryComponent
            it={{
              ...it,
              // image: {
              //   name:
              //     index == 0
              //       ? '/imgs/motion/service/1.webp'
              //       : index == 1
              //         ? '/imgs/motion/service/1.webp'
              //         : '/imgs/motion/service/2.webp',
              // },
            }}
            index={index}
            key={index}
          />
        ))}
      </div>
    </div>
  );
}
